import { inject, Injectable, Injector } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FeedbackDialogData } from './feedback.abstraction';
import { FeedbackComponent } from './feedback.component';

@Injectable({ providedIn: 'root' })
export class FeedbackDialog {
  #matDialog = inject(MatDialog);

  open(data: FeedbackDialogData, injector?: Injector): MatDialogRef<unknown> {
    return this.#matDialog.open(FeedbackComponent, {
      data,
      injector,
      panelClass: 'right-angle-corner-dialog',
      position: {
        top: '0',
        right: '0',
      }
    });
  }
}
